// Module
var code = "<template><compose class=\"column grow-xs-1 shrink-xs-0\" view-model.bind=\"vm\"></compose></template>";
// Exports
module.exports = code;